const ApplicationName = 'Billing-International';
const billIntPrefix = 'International-';
const Links = Object.freeze({
    submitEnquiry: billIntPrefix + 'Submit enquiry',
    uploadAttacchmentSubmitEnquiry: billIntPrefix + 'Upload attachment in submit enquiry',
    addComment: billIntPrefix + 'Add comment',
    uploadAttacchmentComment: billIntPrefix + 'Upload attachment in comment',
    customerAttachmentDownload: billIntPrefix + 'Customer attachment download',
    telstraAttachmentDownload: billIntPrefix + 'Telstra attachment download',
    attachmentSubmitEnquiry: 'Total attachments: ',
    attachmentcaseDetails: 'Total attachments: ',
    companyDropdown: (companyName: string) => `Selected ${companyName} Company`,
});

const Components = Object.freeze({
    casesListComponent: billIntPrefix + 'Tracking-Enquiries',
    billingSubmitEnquiry: billIntPrefix + 'Billing Submit enquiry form',
    billingEnquiryDetail: billIntPrefix + 'Case detail page',
    newCaseComponent: 'New Enquiry',
    caseDetailsComponent: 'Enquiry Details'
});

export {
    ApplicationName,
    Components,
    Links
};
